import { Plugin } from '../../types';

export const viewport: Plugin = {
  name: 'viewport',
  page: (emit) => {
    window.addEventListener('resize', () => {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      emit({
        size: [vw, vh],
        time: Date.now()
      })
    });

  },
  reduce: (previousEvents, event) => {
    /**@return Event[] */
    const previousEvent = previousEvents[previousEvents.length - 1]
    if (!previousEvent) {
      return [event]
    }
    if (previousEvent.name === 'viewport' && event.name === 'viewport') {
      return previousEvents.slice(0, -1).concat([{ ...event, time: previousEvent.time }])
    }
    return previousEvents.concat([event])
  },
  test: {
    matchers: {
      toSetViewportSize: async (page, width, height) => {
        await page.setViewportSize({
          width,
          height
        })

        return { pass: true, message: () => `Page changed viewport size to ${width}x${height}` };

      },
    }
  },
  generate(event) {
    return `
    it("changes the window size", async () => {
      await expect(page).toSetViewportSize(${event.size[0]},${event.size[1]})
    })
`
  }

}
export default viewport